"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var Title = _ref.Title,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  var theme = (0, _avlComponents.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      rounded p-10 shadow-xl\n      ".concat(theme.accent1, " ").concat(className, "\n    ")
  }, !Title ? null : typeof Title === "function" ? /*#__PURE__*/_react["default"].createElement(Title, null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-3xl font-bold mb-2"
  }, Title), children);
};

exports["default"] = _default;